import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function OAuthAuthorize() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleAuthorize = async () => {
      // Get all query parameters
      const queryParams = new URLSearchParams(searchParams);
      const redirectUri = queryParams.get('redirect_uri');
      const state = queryParams.get('state');
      const clientId = queryParams.get('client_id');

      console.log('[OAuth Redirect] OAuthAuthorize: start', { redirectUri, state, clientId });

      // Construct the backend URL with all query parameters
      const backendUrl = `${process.env.REACT_APP_API_BASE_URL}/oauth/authorize?${queryParams.toString()}`;

      console.log('[OAuth Redirect] OAuthAuthorize: redirecting to backend', { backendUrl: backendUrl.substring(0, 80) + '...' });

      // Redirect to the backend endpoint
      window.location.href = backendUrl;

      console.log('[OAuth Redirect] OAuthAuthorize: window.location.href set (navigate to backend should occur)');
    };

    handleAuthorize();
  }, [searchParams]);

  return null; // This component doesn't render anything
}

export default OAuthAuthorize; 